export enum WidgetVisibility {
	SHOWN = 'SHOWN',
	HIDDEN = 'HIDDEN'
}

